import script from "./OpenPositions.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenPositions.vue?vue&type=script&setup=true&lang=js"

import "./OpenPositions.vue?vue&type=style&index=0&id=1c446ba8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c446ba8"]])

export default __exports__